import { hasAccess, isAuthenticated } from '@/auth/authGuard'
import { LazyLoadView } from '@/router/utils'

export default [
  {
    name: 'contacts',
    path: '/contacts',
    component: () => LazyLoadView(import(/* webpackChunkName: "contacts" */ '@/views/Contact/Contacts')),
    beforeEnter: hasAccess('contacts'),
  },
  {
    name: 'contact-create',
    path: '/contacts/create',
    component: () => LazyLoadView(import(/* webpackChunkName: "contact-mutate" */ '@/views/Contact/Mutate.vue')),
    beforeEnter: isAuthenticated,
  },
  {
    name: 'contact-edit',
    path: '/contacts/:id/edit',
    props: true,
    component: () => LazyLoadView(import(/* webpackChunkName: "contact-mutate" */ '@/views/Contact/Mutate.vue')),
    beforeEnter: isAuthenticated,
  },
  {
    name: 'contact-dashboard',
    path: '/contact/:id',
    props: true,
    component: () => LazyLoadView(import(/* webpackChunkName: "contact-dashboard" */ '@/views/Contact/Dashboard')),
    beforeEnter: isAuthenticated,
  },
]
